// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  // {
  //   title: 'dashboard',
  //   path: '/dashboard/app',
  //   icon: icon('ic_analytics'),
  // },
  {
    title: 'user management',
    path: '/user',
    allowedRoles: ['admin'],
    icon: icon('ic_user'),
  },
  {
    title: 'product management',
    path: '/products',
    allowedRoles: ['admin', 'manager', 'data-entry'],
    icon: icon('ic_cart'),
  },
  {
    title: 'sold management',
    path: '/sold',
    allowedRoles: ['admin', 'manager', 'data-entry'],
    icon: icon('ic_analytics'),
  },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
